//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Overzicht van de Opbouw producten waar de premie van berekend kan worden.
     * @return De lijst met gevonden producten
     */
    availableProducts(): Promise<Product[]> {
        let url_ = this.baseUrl + "/Opbouw/Producten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAvailableProducts(_response);
        });
    }

    protected processAvailableProducts(response: Response): Promise<Product[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Product[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Foutmeldingen;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product[]>(null as any);
    }

    /**
     * Opbouw premie berekening voor één of meerdere producten.
     * @param body (optional) Parameters voor de berekening
     * @return Het resultaat van de berekening
     */
    multiple(body: MultipleOpbouwInput | null | undefined): Promise<OpbouwOutput> {
        let url_ = this.baseUrl + "/Opbouw/Multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMultiple(_response);
        });
    }

    protected processMultiple(response: Response): Promise<OpbouwOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpbouwOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpbouwOutput;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpbouwOutput>(null as any);
    }

    /**
     * Opbouw premie berekening voor alle producten.
     * @param body (optional) Input nodig voor de berekening.
     * @return Het resultaat van de berekening
     */
    all(body: OpbouwInput | null | undefined): Promise<OpbouwOutput> {
        let url_ = this.baseUrl + "/Opbouw/All";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: Response): Promise<OpbouwOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpbouwOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("Er is iets fout gegaan", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpbouwOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    getVersionInfo(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetVersionInfo(_response);
        });
    }

    protected processGetVersionInfo(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }
}

export interface BadRequestResult {
    statusCode: number;
}

/** BetalingsTermijnEnum PerMaand = 1, PerTweeMaanden = 2, PerKwartaal = 3, PerHalfJaar = 6, PerJaar = 12, Eenmalig = 99 */
export enum BetalingsTermijnEnum {
    PerMaand = "PerMaand",
    PerTweeMaanden = "PerTweeMaanden",
    PerKwartaal = "PerKwartaal",
    PerHalfJaar = "PerHalfJaar",
    PerJaar = "PerJaar",
    Eenmalig = "Eenmalig",
}

/** Geeft een eenvoudige mogelijkheid om foutmeldingen door te geven. */
export interface Foutmeldingen {
    isValid: boolean;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** GeslachtOpties Man = 1, Vrouw = 2 */
export enum GeslachtOpties {
    Man = "Man",
    Vrouw = "Vrouw",
}

/** Input voor het berekenen van opbouw met meerdere producten */
export interface MultipleOpbouwInput {
    data: OpbouwInput | null;
    /** Lijst met te berekenen producten */
    producten: number[] | null;
}

/** Algemene gegevens van het opbouwproduct. */
export interface OpbouwAlgemeenInput {
    /** Ingangsdatum van verzekering */
    ingangsDatum: string | null;
    /** Looptijd in maanden */
    looptijdInMaanden: number | null;
    /** Is verpand */
    verpand: boolean | null;
    /** Premie is gesplitst */
    premieSplitsing: boolean | null;
    /** Dekt kinderen */
    kindDekking: boolean | null;
    /** Indicatie of er al dan niet sprake is van een premiereserve (waardeopbouw) */
    premiereserve: boolean | null;
    soortBerekening: SoortBerekeningOpties;
}

/** Algemene gegevens van het doelkapitaal. */
export interface OpbouwDoelkapitaalInput {
    /** Bedrag van het doelkapitaal */
    bedrag: number | null;
    /** Percentage van het doelkapitaal */
    percentage: number | null;
    /** Percentage rekenrente van het doelkapitaal */
    percentageRekenrente: number | null;
}

/** Invoer voor de berekening van een opbouwproduct. */
export interface OpbouwInput {
    /** Unieke identificatie */
    id: string;
    algemeen: OpbouwAlgemeenInput | null;
    /** Gegevens over de verzekerden. Let op! Bij gebruik van XML is het ArrayItem verzekerde in plaats van de in Swagger gegenereerde verzekerden. */
    verzekerden: OpbouwVerzekerdeInput[] | null;
    premie: OpbouwPremieInput | null;
    doelkapitaal: OpbouwDoelkapitaalInput | null;
    leningdeel: OpbouwLeningdeelInput | null;
}

/** Algemene gegevens van het leningdeel. */
export interface OpbouwLeningdeelInput {
    /** Rentepercentage het leningdeel */
    rentepercentage: number | null;
    /** Bedrag van het leningdeel */
    bedrag: number | null;
    /** De voor de rentebepaling te gebruiken rentevastperiode. */
    rentevastPeriode: number | null;
    /** De voor de rentebepaling te gebruiken rentevastperiode. */
    rentebedenkPeriode: number | null;
}

/** Resultaat van de berekeningen */
export interface OpbouwOutput {
    /** Uitvoer van de berekening van een opbouwverzekering */
    resultaten: OpbouwResultaat[] | null;
    messages: string[] | null;
    isValid: boolean;
}

/** Algemene gegevens van de premie. */
export interface OpbouwPremieInput {
    /** Premieduur in maanden */
    looptijdInMaanden: number | null;
    /** Looptijd hoog/laag constructie in maanden */
    looptijdHoogLaagInMaanden: number | null;
    /** Hoog / laag verhouding */
    hoogLaagPercentage: number | null;
    /** Ingangsdatum van verzekering */
    eindDatum: string | null;
    betalingstermijn: BetalingsTermijnEnum | null;
    /** Bedrag van evt. aanvangsstorting */
    aanvangsstorting: number | null;
}

/** Resultaat van een berekening */
export interface OpbouwResultaat {
    /** Unieke identificatie */
    id: string;
    /** Productcode waarvoor de uitvoer geldt. */
    productcode: number;
    /** Berekend Premiebedrag */
    premie: number;
    /** Berekende aanvangsstorting */
    aanvangsstorting: number;
    /** Berekend Premiebedrag hoog */
    premieHoog: number;
    /** Berekende premies. */
    melding: string | null;
    messages: string[] | null;
    isValid: boolean;
}

/** Gegevens van een verzekerde van een opbouwverzekering. */
export interface OpbouwVerzekerdeInput {
    /** Unieke identificatie */
    id: number | null;
    /** Eindkapitaal */
    eindkapitaal: number | null;
    /** Verzekerd bedrag */
    verzekerdBedrag: number | null;
    uitkering: UitkeringOpties | null;
    /** Is een roker */
    roker: boolean | null;
    geslacht: GeslachtOpties | null;
    /** Geboortedatum */
    geboorteDatum: string | null;
    /** Annuiteits percentage */
    annuiteitsPercentage: number | null;
}

/** Product */
export interface Product {
    /** Id */
    id: number;
    /** Naam van het product */
    naam: string | null;
}

/** SoortBerekeningOpties Doelkapitaal = 1, Premie = 2, Rendement = 3 */
export enum SoortBerekeningOpties {
    Doelkapitaal = "Doelkapitaal",
    Premie = "Premie",
    Rendement = "Rendement",
}

/** UitkeringOpties LineairDalend = 1, AnnuitairDalend = 2, Gelijkblijvend = 3, Eenjarig = 4, NabestaandeRente = 7 */
export enum UitkeringOpties {
    LineairDalend = "LineairDalend",
    AnnuitairDalend = "AnnuitairDalend",
    Gelijkblijvend = "Gelijkblijvend",
    Eenjarig = "Eenjarig",
    NabestaandeRente = "NabestaandeRente",
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}